import React from 'react';

import { withRef } from '@udecode/cn';
import { useIndentButton } from '@udecode/plate-indent';

import { Icons } from '@/components/plate-ui/Icons';

import { ToolbarButton } from './Toolbar';

export const IndentToolbarButton = withRef(
  (rest, ref) => {
    const { props } = useIndentButton();

    return (
      <ToolbarButton ref={ref} tooltip="Indent" {...props} {...rest}>
        <Icons.indent />
      </ToolbarButton>
    );
  }
);